import ErrorIcon from '@mui/icons-material/Error';
import classes from './index.module.css';

export default function InfoHover({ title, infoIcon, style = {} }) {
  return (
    <span className={classes.hover}>
      <span className={classes.info_icon}>
        {infoIcon || (
          <ErrorIcon
            fontSize="small"
            sx={{
              '&': {
                color: '#5C5F62',
                marginLeft: '4px',
              },
            }}
          />
        )}
      </span>

      <span className={classes.hover_text}>
        <section className={classes.hover_text_tip} style={style}>
          {title}
        </section>
        <section className={classes.hover_triangle} style={{ borderTop: `solid 9px ${style.background}` }} />
      </span>
    </span>
  );
}
